<template lang="pug">
  div.waste-generators.individual-area-update
    router-view(
    :parentItem="fields"
    ).modal-to-front

    e-form-modal(
    ref="modalForm"
    @submitModalForm="sendForm()"
    @deleteItem="deleteItem()"
    :hideDeleteButton="(fields.id ? true : false)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs(
        v-model="tabView"
        :tabs="[{tab1: 'Общие сведения'},{bills: 'Лицевые счета'}]"
        )
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView == 'tab1'")
            div.body
              div.col
                e-form-subtitle(text="Реквизиты")

                e-form-group(
                v-if="!isEdit"
                name="fact_address"
                inputType="address"
                label="Адрес"
                :model="fields"
                tabView="tab1"
                :required="true"
                :addressData="addressData"
                addressIdFieldName="address_id"
                :geoFields="['latitude', 'longitude']"
                )

                e-form-group(
                name="apartments_area"
                inputType="input"
                label="Общая площадь (кв.м.)"
                :model="fields"
                tabView="tab1"
                :disabled="true"
                )

                e-form-group(
                  name="residents_count"
                  inputType="input"
                  label="Общее количество проживающих"
                  :model="fields"
                  tabView="tab1"
                  :disabled="true"
                )

                e-form-group(
                    name="account_count"
                    inputType="input"
                    label="Количество лицевых счетов"
                    :model="fields"
                    tabView="tab1"
                    :disabled="true"
                )

                e-form-group(
                  name="checking_account_number"
                  inputType="input"
                  label="Номер расчётного счёта в банке"
                  :model="fields"
                  tabView="tab1"
                  :disabled="true"
                )

              div.col-2-3
                e-form-group(
                tabView="tab1"
                :model="fields"
                _label="Почтовое отделение"
                name="post_office_id"
                :required="true"
                )
                  slot
                    post-office(:fields="fields")


                div
                  e-button-edit(
                    v-if="item && item.id"
                    @click="openHouseMoveRecalc()"
                    label="Перерасчет по типу дома"
                  ).btn-with-text

                  house-move-recalc(
                    v-if="houseMoveRecalcOpened"
                    @close="closeHouseMoveRecalc()"
                    @updated="updatedHouseMoveRecalc"
                    :model="fields"
                    :normativeType="NORMATIVE_TYPE_INDIVIDUAL"
                  )

          // лицевые счета
          div(v-show="tabView == 'bills'")
            garbage-bank-books(
            :fields="fields"
            ref="garbageBankBooksTable"
            tabView="bills"
            type="BANK_ACCOUNT_TYPE_HOUSE"
            )

</template>

<script>
  import {garbage, core, wasteGenerators, services} from '../../api/api-endpoints.js'
  import wasteGeneratorsForm from './mixins/waste-generators-form'
  import {BILL_HOUSE_TYPE_INDIVIDUAL, GARBAGE_TYPE_INDIVIDUAL_AREA} from "../../config/config"
  import GarbageBankBooks from "./components/garbage-bank-books"
  import PostOffice from "./components/post-office";
  import HouseMoveRecalc from "./components/house-move-recalc";

  export default {
    mixins: [wasteGeneratorsForm],
    components: {
      HouseMoveRecalc,
      PostOffice,
      GarbageBankBooks
    },
    data () {
      return {
        tabView: 'tab1',
        fields: {
          type: BILL_HOUSE_TYPE_INDIVIDUAL,
          apartments_area: 'Значение будет рассчитано после сохранения',
          name: '',
          status_id: '',
          business_category_id: '',
          latitude: '',
          longitude: '',
          garbage_source_type_id: GARBAGE_TYPE_INDIVIDUAL_AREA,
          garbage_source_category_id: '',
          area: ''
        }
      }
    },
    methods: {
      getBankBookCreateUrl () {
        return wasteGenerators.bankBookHouseCreate(this.fields.id)
      },
      prepareFieldsForSend (fields = {}) {
        // on backend name required
        fields.name = fields.fact_address
        return fields
      },
      getCollectionEndpoint () {
        return core.collection('garbage_category')
      },
      getDeleteUrl (id) {
        return garbage.garbageDelete(id)
      },
      getUpdateOrCreateUrl () {
        return services.serviceCreateOrUpdate(this.$route.params.id)
      },
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return services.service(route.params.id)
      }
    }
  }
</script>
